import { render, staticRenderFns } from "./logisticsLink.vue?vue&type=template&id=d9d97f80&scoped=true"
import script from "./logisticsLink.vue?vue&type=script&lang=js"
export * from "./logisticsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d97f80",
  null
  
)

export default component.exports